@if (coordinateIsInUSOrTerritoriesResult) {
    <app-validation-error-list
        [validationResult]="coordinateIsInUSOrTerritoriesResult"
    ></app-validation-error-list>
}

<mat-checkbox
    #toggleLatitudeLongitudeFormatElement
    color="primary"
    class="mb-2"
    (change)="toggleLatitudeLongitudeFormat()"
>
    <span class="text-tertiary-900 text-sm font-normal select-none"
        >Show or enter LAT/LONG coordinates in decimal format</span
    >
</mat-checkbox>

@if (!latitudeLongitudeInDecimalFormat) {
    <div class="flex flex-col" [formGroup]="dmsForm">
        <h3 class="text-sm font-medium !mb-1">Latitude:</h3>
        <div class="flex space-x-2">
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getDegreesLabel() }}</mat-label>
                <input
                    title="Degrees"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="latitudeDegrees"
                    (input)="updateDecimalLatLongFormControls('latitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getMinutesLabel() }}</mat-label>
                <input
                    title="Minutes"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="latitudeMinutes"
                    (input)="updateDecimalLatLongFormControls('latitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getSecondsLabel() }}</mat-label>
                <input
                    title="Seconds"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="latitudeSeconds"
                    (input)="updateDecimalLatLongFormControls('latitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>

            <ng-template #latitudeDirectionField>
                <mat-form-field
                    appearance="outline"
                    class="w-full max-w-[165px]"
                    color="primary"
                >
                    <mat-label>North/South</mat-label>
                    <mat-select
                        formControlName="latitudeDirection"
                        (selectionChange)="
                            updateDecimalLatLongFormControls('latitude');
                            validateCoordinateIsInUSOrTerritories()
                        "
                    >
                        @for (
                            option of latitudeDirectionOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </ng-template>

            @if (compact) {
                <ng-container
                    *ngTemplateOutlet="latitudeDirectionField"
                ></ng-container>
            } @else {
                <app-application-form-field
                    label="North/South"
                    [tooltipMessage]="messages.latitudeLongitudeTooltip"
                    [inline]="true"
                    [dialogTooltip]="true"
                    dialogTooltipTitle="Latitude/Longitude"
                    [showTooltipIcon]="true"
                >
                    <ng-container
                        *ngTemplateOutlet="latitudeDirectionField"
                    ></ng-container>
                </app-application-form-field>
            }
        </div>
        <h3 class="text-sm font-medium !mb-1 -mt-1">Longitude:</h3>
        <div class="flex space-x-2">
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getDegreesLabel() }}</mat-label>
                <input
                    title="Degrees"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="longitudeDegrees"
                    (input)="updateDecimalLatLongFormControls('longitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getMinutesLabel() }}</mat-label>
                <input
                    title="Minutes"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="longitudeMinutes"
                    (input)="updateDecimalLatLongFormControls('longitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                [ngClass]="{
                    'w-[300px]': compact,
                    'max-w-[120px]': !compact,
                }"
                color="primary"
            >
                <mat-label>{{ getSecondsLabel() }}</mat-label>
                <input
                    title="Seconds"
                    matInput
                    type="number"
                    class="hide-step"
                    formControlName="longitudeSeconds"
                    (input)="updateDecimalLatLongFormControls('longitude')"
                    (focusout)="validateCoordinateIsInUSOrTerritories()"
                />
            </mat-form-field>

            <ng-template #longitudeDirectionField>
                <mat-form-field
                    appearance="outline"
                    class="w-full max-w-[165px]"
                    color="primary"
                >
                    <mat-label>East/West</mat-label>
                    <mat-select
                        formControlName="longitudeDirection"
                        (selectionChange)="
                            updateDecimalLatLongFormControls('longitude');
                            validateCoordinateIsInUSOrTerritories()
                        "
                    >
                        @for (
                            option of longitudeDirectionOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">{{
                                option.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </ng-template>

            @if (compact) {
                <ng-container
                    *ngTemplateOutlet="longitudeDirectionField"
                ></ng-container>
            } @else {
                <app-application-form-field
                    label="East/West"
                    [tooltipMessage]="messages.latitudeLongitudeTooltip"
                    [inline]="true"
                    [dialogTooltip]="true"
                    dialogTooltipTitle="Latitude/Longitude"
                    [showTooltipIcon]="true"
                >
                    <ng-container
                        *ngTemplateOutlet="longitudeDirectionField"
                    ></ng-container>
                </app-application-form-field>
            }
        </div>
    </div>
}

@if (latitudeLongitudeInDecimalFormat) {
    <ng-template #latitudeField>
        <mat-form-field
            appearance="outline"
            class="w-full"
            [ngClass]="{
                'max-w-[400px]': !compact,
            }"
            color="primary"
        >
            <mat-label>Latitude</mat-label>
            <input
                title="Latitude"
                matInput
                [imask]="latitudeLongitudeMaskConfig.latitude"
                [formControl]="latitudeControl"
                (focusout)="
                    updateDmsLatLongFormControlsAndValidateCoordinates(
                        'latitude'
                    )
                "
            />
        </mat-form-field>
    </ng-template>

    <ng-template #longitudeField>
        <mat-form-field
            appearance="outline"
            class="w-full"
            [ngClass]="{
                'max-w-[400px]': !compact,
            }"
            color="primary"
        >
            <mat-label>Longitude</mat-label>
            <input
                title="Longitude"
                matInput
                [imask]="latitudeLongitudeMaskConfig.longitude"
                [formControl]="longitudeControl"
                (focusout)="
                    updateDmsLatLongFormControlsAndValidateCoordinates(
                        'longitude'
                    )
                "
            />
        </mat-form-field>
    </ng-template>

    @if (compact) {
        <ng-container *ngTemplateOutlet="latitudeField"></ng-container>
    } @else {
        <app-application-form-field
            label="Latitude"
            [tooltipMessage]="messages.latitudeLongitudeTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Latitude"
            [showTooltipIcon]="true"
        >
            <ng-container *ngTemplateOutlet="latitudeField"></ng-container>
        </app-application-form-field>
    }

    @if (compact) {
        <ng-container *ngTemplateOutlet="longitudeField"></ng-container>
    } @else {
        <app-application-form-field
            label="Longitude"
            [tooltipMessage]="messages.latitudeLongitudeTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Longitude"
            [showTooltipIcon]="true"
        >
            <ng-container *ngTemplateOutlet="longitudeField"></ng-container>
        </app-application-form-field>
    }
}
